import React from 'react';
// import Listing from './Listing';
import { useNavigate, Link, Outlet } from "react-router-dom"; // Import useNavigate and Link


const Integrations = () => {
  return (
    <Outlet />
  );
};

export default Integrations;
